import React from 'react';
import { MapPin, Wrench, FileText, Shield, CheckCircle, Award } from 'lucide-react';
export function WhyChoose() {
  const cards = [{
    icon: MapPin,
    title: 'Local Southeast Michigan Auto Glass Team',
    copy: 'Serving drivers from Howell, Ann Arbor, Novi and nearby communities with urgent auto glass help.'
  }, {
    icon: Wrench,
    title: 'Certified Auto Glass Technicians',
    copy: 'Professional repair and replacement for windshields, side glass, rear glass, door glass and vehicle glass.'
  }, {
    icon: FileText,
    title: 'Free Auto Glass Estimates',
    copy: 'Get clear next steps and an estimate before moving forward.'
  }, {
    icon: Shield,
    title: 'Works With Most Insurance',
    copy: 'The team can help with insurance information, claim coordination and scheduling.'
  }, {
    icon: CheckCircle,
    title: 'Quality Glass Options',
    copy: "Kosin's uses high-quality glass that meets or exceeds OEM standards."
  }, {
    icon: Award,
    title: 'Lifetime Workmanship Warranty',
    copy: "Vehicle glass workmanship is backed by Kosin's lifetime warranty."
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-1155" data-mp="3iv44kr1qmxcf">
      <div className="max-w-7xl mx-auto" data-id="element-1156" data-mp="3mvo4g2dp4f29">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-1157" data-mp="3muld5tcgoalt">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-normal leading-tight" data-id="element-1158" data-mp="38weql9cypx1g">
            Why Drivers Call{' '}
            <span className="text-emergencyBrand-red" data-id="element-1159" data-mp="3dwj72zdverro">Kosin's Glass</span> for
            Urgent Auto Glass
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-1160" data-mp="33ws9upxxdynw">
          {cards.map((card, i) => <div key={i} className="bg-white rounded-lg p-6 border border-slate-200 hover:border-emergencyBrand-red/40 hover:shadow-md transition-all" data-id="element-1161" data-mp="y3tyoydxiaqm" data-mpi={i}>
              <div className="flex items-center gap-4 mb-4" data-id="element-1162" data-mp="2b35boankdryt">
                <div className="w-11 h-11 bg-emergencyBrand-redLight rounded-lg flex items-center justify-center shrink-0" data-id="element-1163" data-mp="2b0j5aecetii6">
                  <card.icon className="w-5 h-5 text-emergencyBrand-red" data-id="element-1164" data-mp="221nv6r68vo9l" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 leading-tight" data-id="element-1165" data-mp="1x3482nfx06fn">
                  {card.title}
                </h3>
              </div>
              <p className="text-slate-600" data-id="element-1166" data-mp="2tslp1ykclewn">{card.copy}</p>
            </div>)}
        </div>
      </div>
    </section>;
}